export class APIError extends Error {
    constructor(type, statusCode, rateLimit, ...messages) {
        super(messages.join('. '));
        this.type = type;
        this.statusCode = statusCode;
        this.rateLimit = rateLimit;
        this.messages = messages;
    }
}
